import styles from "./index.module.css";
import { PulseLoader } from "react-spinners";

const FnbPriceChangeTable = (props) => {

  const calculatePercentageChange = (oldPrice, newPrice) => {
    if (!oldPrice || !newPrice || oldPrice === 0) return 0;
    return ((newPrice - oldPrice) / oldPrice) * 100;
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["table"]}>
        <div className={styles["thead"]}>
          <div className={styles["thead_cell"]}>Product Name</div>
          <div className={styles["thead_cell"]}>Store Name</div>
          <div className={styles["thead_cell"]}>Terminal Name</div>
          <div className={styles["thead_cell"]}>Old Price</div>
          <div className={styles["thead_cell"]}>New Price</div>
          <div className={styles["thead_cell"]}>Difference %</div>
        </div>
        {props.loading ? (
          <div className="loader-container">
            <PulseLoader />
          </div>
        ) : (
          <div className={styles["tdata"]}>
            {props?.data?.map((product, index) => {
              const percentageChange = calculatePercentageChange(product.old_price, product.new_price);
              return (
                <div className={styles["trow"]} key={index}>
                  <div 
                    className={styles["trow_cell"]}
                  >
                    {product.product_name}
                  </div>
                  <div className={styles["trow_cell"]}>{product.store_name}</div>
                  <div className={styles["trow_cell"]}>{product.terminal_name}</div>
                  <div className={styles["trow_cell"]}>
                    ${parseFloat(product.old_price).toFixed(2)}
                  </div>
                  <div className={styles["trow_cell"]}>
                    ${parseFloat(product.new_price).toFixed(2)}
                  </div>
                  <div className={styles["trow_cell"]}>
                    <span 
                      className={`${styles["percentage_change"]} ${
                        percentageChange > 0 ? styles["up"] : percentageChange < 0 ? styles["down"] : ""
                      }`}
                    >
                      {percentageChange > 0 ? "+" : ""}{percentageChange.toFixed(1)}%
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FnbPriceChangeTable;
